
/* injects from baggage-loader */

import React from "react";
import {t} from "../../../helpers/translator";
import PropTypes from 'prop-types';
import Config from '../../../config/main';
import {BETSLIP_TYPE_SINGLE} from "../../../helpers/sport/betslip";

class StaticStake extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            type: 0
        };

        this._staticStakes;
    }

    get staticStakes () {
        if (!this._staticStakes) {
            const authData = JSON.parse(sessionStorage.getItem('authData'));
            this._staticStakes = Config.staticStakeCounts[authData.currency.toLowerCase()] || Config.staticStakeCounts.default;
        }

        return this._staticStakes;
    }

    componentDidMount () {
        this.staticStakes.length && Config.firstStaticStakeAsDefault && this.props.setStake(this.staticStakes[0]);
    }

    handleNumberFieldClick (num) {
        return () => {
            if (this.props.activeStake === num) {
                this.props.setStake('');
            } else {
                this.props.setStake(num);
            }
        };
    }
    // static getDerivedStateFromProps (nextProps, prevState) {
    //     const stake = nextProps.betSlip.type === BETSLIP_TYPE_SINGLE && nextProps.events.length
    //         ? +nextProps.events[0].singleStake
    //         : +nextProps.betSlip.stake;

    //     if (nextProps.betSlip.type !== prevState.type || stake !== prevState.activeStake) {
    //         return ({
    //             activeStake: stake,
    //             type: nextProps.betSlip.type
    //         });
    //     }
    //     return null;
    // }

    getAllAvaliableStake () {
        return () => {
            // TO DO --START
            const balance = sessionStorage.getItem("balance") && JSON.parse(sessionStorage.getItem("balance")).session_balance;
            const userBalance = this.props.user.profile && this.props.user.profile.balance;
            const { terminalBalance } = this.props;
            let currentbalance;
            if (userBalance) {
                currentbalance = userBalance;
            } else {
                if (terminalBalance !== undefined) {
                    if (terminalBalance !== null) {
                        currentbalance = terminalBalance;
                    } else {
                        if (balance === null) {
                            currentbalance = 0;
                        } else {
                            currentbalance = balance;
                        }
                    }
                } else {
                    if (balance === null) {
                        currentbalance = 0;
                    } else {
                        currentbalance = balance;
                    }
                }
            }
            // TO DO --END
            this.props.setStake(currentbalance);
        };
    }

    fillNumbers () {
        //const symbol = Config.main.currency[this.props.currency];
        return this.staticStakes.map((num) => (<li key={num} onClick={this.handleNumberFieldClick(num)} className={this.props.activeStake === num ? "active" : ""}><span>{num}</span></li>));
    }
    render () {
        return (
            <div className={`virtual-staticStack-wrapper ${this.props.betSlipType === BETSLIP_TYPE_SINGLE && "single-betslip-StaticStake"}`}>
                <div className="virtual-staticStack-m">
                    <ul className="key-numbers-m staticStake">
                        {this.fillNumbers()}
                        {
                            !Config.hideMaxStake &&
                                <li onClick={this.getAllAvaliableStake()}>
                                    <span>{t("MAX")}</span>
                                </li>
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

StaticStake.propTypes = {
    setStake: PropTypes.func.isRequired,
    currency: PropTypes.objectOf(PropTypes.any).isRequired,
    user: PropTypes.objectOf(PropTypes.any).isRequired,
    terminalBalance: PropTypes.any,
    betSlipType: PropTypes.number
};

export default StaticStake;